import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';
import LoadingIndicator from "flarum/common/components/LoadingIndicator";
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
export default class searchRelevantComponent extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    const _this = this;
    this.keyword = this.attrs.keyword;
    this.limit = this.attrs.limit || -1;
    this.moreResults = false;
    this.loading = true;
    this.searchDiscussionList = [];
    this.filterSearchDiscussionSort = Stream(this.attrs.sort || "lastest");
    this.loadResult();
  }
  onupdate() {
    const keyword = this.attrs.keyword.trim();
    if (this.keyword !== keyword) {
      this.keyword = keyword;
      this.filterItem();
    }
  }
  filterItem(e) {
    this.searchDiscussionList = [];
    this.loading = true;
    m.redraw();
    this.loadResult();
  }
  view() {
    const searchDiscussionList = this.searchDiscussionList;
    let loading;
    if (this.loading) {
      loading = LoadingIndicator.component({
        size: "large"
      });
    }
    const params = {
      params: {
        q: this.keyword
      }
    };
    return m("div", {
      className: "DiscussionList searcRelevantContentContainer"
    }, searchDiscussionList.map(discussion => {
      return m("ul", {
        className: "DiscussionList-discussions"
      }, m("li", {
        "data-id": discussion.id(),
        role: "article"
      }, DiscussionListItem.component({
        discussion,
        params
      })));
    }), !this.loading && searchDiscussionList.length === 0 && this.limit === -1 && m("div", null, m("div", {
      style: "font-size:1.4em;color: var(--muted-more-color);text-align: center;height: 300px;line-height: 100px;"
    }, app.translator.trans("ziven-community-core.lib.search-list-empty"))), !loading && this.hasMoreResults() && m("div", {
      className: "Kater-loadMore",
      style: "text-align:center;padding:20px"
    }, m(Button, {
      className: 'Button Button--primary',
      disabled: this.loading,
      loading: this.loading,
      onclick: () => this.loadMore()
    }, app.translator.trans('kater-community-core.lib.load-more'))), loading && m("div", {
      className: "Kater-loadMore"
    }, loading));
  }
  filterItem(e) {
    this.searchDiscussionList = [];
    this.loading = true;
    m.redraw();
    this.loadResult();
  }
  loadMore() {
    this.loading = true;
    this.loadResult(this.searchDiscussionList.length);
  }
  hasMoreResults() {
    return this.limit !== -1 ? false : this.moreResults;
  }
  loadResult(offset) {
    if (offset === void 0) {
      offset = 0;
    }
    let include = app.discussions.requestParams().include;
    include.push("firstPost", "mostRelevantPost", "mostRelevantPost.user");
    let page = {
      offset,
      limit: 5
    };
    if (this.limit === -1) {
      delete page.limit;
    }
    let filterKeyword = this.keyword;
    app.store.find("discussions", {
      include: include.join(","),
      sort: this.sortList().join(","),
      filter: {
        q: filterKeyword
      },
      page: page
    }).catch(() => {}).then(this.parseResults.bind(this));
  }
  parseResults(results) {
    this.moreResults = !!results.payload.links && !!results.payload.links.next;
    [].push.apply(this.searchDiscussionList, results);
    this.loading = false;
    m.redraw();
    return results;
  }
  sortList() {
    const list = [];
    const filterSearchDiscussionSort = this.filterSearchDiscussionSort();
    switch (filterSearchDiscussionSort) {
      case "hotness":
        list.push("-hotness");
        break;
      case "createdAt":
        list.push("-createdAt");
        break;
    }
    return list;
  }
}
flarum.reg.add('ziiven-ziven-core', 'forum/components/searchRelevantComponent', searchRelevantComponent);